import { Select } from "components/shared/form";
import policy from "policies";
import React from "react";

export default function ReportSnapshotForm(props) {
    const { data, onChange, config, roles, organizationId } = props;

    return (
        <Select
            {...config.userId}
            url={(params) => config.userId.url({ ...params, organizationId })}
            value={data.userId}
            onChange={onChange}
            disabled={!policy("user", { user: { roles } }).isAdminWithWriteAccess()}
        />
    );
}
